import './style.less';

export default function($log, $scope, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.routeParams = $stateParams;

  vm.selectAll = (select, instructors) => {
    instructors.forEach(instructor => {
      instructor.selected = select;
    });
    vm.updateSelected();
  };

  vm.updateSelected = () => (vm.selected = vm.event.instructors.filter(instructor => instructor.selected).length);

  vm.submit = () => {
    vm.submitBtn = true;

    vm.event.instructors.forEach(instructor => {
      instructor.display = false;
      instructor.suppressCert = vm.suppress;
    });

    vm.action({ instructors: vm.event.instructors })
      .then(() => {
        vm.selectAll(false, vm.event.instructors);
        vm.submitBtn = false;
      })
      .catch(error => {
        vm.selectAll(false, vm.event.instructors);
        vm.submitBtn = false;
        throw error;
      });
  };

  function activate() {
    $log.debug('Event Manager Issue Instructor Credit Component Activated');
    vm.selected = 0;
    try {
      if (!vm.event) throw new Error('No Event');
      if (!vm.action) throw new Error('No Action');
      vm.loaded = true;
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/issueInstructorCertificates/controller.js